import React from "react";

type OverlayProps = {
  style?: React.CSSProperties;
  zIndex?: number;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

const Overlay = ({ style, zIndex = 1, onClick }: OverlayProps) => {
  return (
    <div
      onClick={onClick}
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        zIndex,
        ...style,
      }}
    />
  );
};

export default Overlay;
